//
//
//
//
//
//
//
//
//
//

export default {
  name: "DefaultButton",
  props: {
    text: {
      type: String,
      default: ''
    },
  },
}
